module.exports = __webpack_public_path__ + "static/media/CFI-ML.fc408daf.png";